/**
 * navigation redux reducer
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {PUSH_STATE, RESTORE_STATE} from "./consts";


const initialState = {
}


/** reducer fur navigation
 *
 * @author Jens Gruschel
 */
export default function navigationReducer(state = initialState, action) {

    switch (action.type) {

        case PUSH_STATE: {
            // generate a new state for the browser
            try {
                window.history.pushState(state, action.title, action.url);
            }
            catch {
                // it's better to continue anyway than letting the application crash in case the state cannot be saved
                // (the browser back button won't work though)
                console.log("error pushing state to browser history");
            }
            return state;
        }

        case RESTORE_STATE: {
            // restore the state given by the action
            return action.state;
        }

        default:
            // pass the latest state to the browser
            try {
                window.history.replaceState(state, "");
            }
            catch {
                // it's better to continue anyway than letting the application crash in case the state cannot be saved
                // (the browser back button won't work though)
                console.log("error replacing browser history state");
            }
            return state;
    }
}
